import { uniq } from 'lodash-es';

import { loadable } from '@change-corgi/core/react/loadable';

import { SAP_L10N_MAP } from 'config/routes-l10n';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

import { resolveSapShortcutLocales } from './shared/resolveSapShortcutLocales';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'start-a-petition-v2',
		path: [
			'/start-a-petition/:step',
			...Object.entries(SAP_L10N_MAP).reduce<string[]>((acc, [locale, details]) => {
				if (details) {
					acc.push(...uniq([`/${locale}/${details.sap}/:step`, `/${locale}/${encodeURIComponent(details.sap)}/:step`]));
				}
				return acc;
			}, []),
		],
		component: loadable(async () => import(/* webpackChunkName: "pages/start_a_petition-v2" */ '../index'), {
			exportName: 'StartAPetition',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: false,
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: true,
			resolveL10n: resolveSapShortcutLocales,
		},
		disableFullRerenderForParams: ['step'],
	},
];
